function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import useSetWhenForItems from "@sprout/client-graphql/dist/mutations/useSetWhenForItems";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { Popover, PopoverReference, PopoverTrigger, Scheduler, usePopoverState } from "sprout-ui-dom";
const PostPageToolbarItemWhen = (props)=>{
    const { item  } = props;
    const popoverState = usePopoverState();
    const { onOpenChange  } = popoverState;
    const authorization = usePostAuthorization(item);
    useActionRegistryGlobalHandler("PAGE_WHEN", useCallback(()=>{
        onOpenChange(true);
        return true;
    }, [
        onOpenChange
    ]), {
        skip: !authorization.schedule
    });
    const setWhenForItems = useSetWhenForItems();
    const handleScheduled = useCallback(({ when , whenReminder  })=>{
        onOpenChange(false);
        setWhenForItems({
            items: [
                item
            ],
            when,
            whenReminder
        });
    }, [
        onOpenChange,
        item,
        setWhenForItems
    ]);
    const items = useMemo(()=>[
            item
        ], [
        item
    ]);
    const handleEscape = useCallback(()=>{
        onOpenChange(false);
    }, [
        onOpenChange
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Popover, _objectSpread({
                placement: "top"
            }, popoverState, {
                children: /*#__PURE__*/ _jsx(Scheduler, {
                    items: items,
                    onScheduled: handleScheduled,
                    onEscape: handleEscape
                })
            })),
            /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, popoverState, {
                children: /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, popoverState, {
                    children: /*#__PURE__*/ _jsx(PageToolbarItem, {
                        action: "PAGE_WHEN"
                    })
                }))
            }))
        ]
    });
};
export default PostPageToolbarItemWhen;
